export default __webpack_public_path__ + "static/media/vr-truck-circle-green.b7f720e1.svg";